import React from 'react';

function Verify() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Verify a Certification</h1>
      <p>Enter a wallet address to search for certifications.</p>
    </div>
  );
}

export default Verify;
